import styled from '@emotion/styled';

const ColorOptionsWrapper = styled('section')({
  margin: -3,
  width: 180,
  display: 'flex',
  flexWrap: 'wrap',
});

export default ColorOptionsWrapper;
